import Routes from './Source/Routes';

function App() {
  return <Routes />;
}

export default App;
